import axios from 'axios'

import sanitizedConfig from '../Config'

export const $file = axios.create({
  // baseURL: sanitizedConfig.REACT_APP_COMPANY_API_URL,
  withCredentials: true,
})

export const $api = axios.create({
  withCredentials: true,
})

// $file.interceptors.request.use(
//   async config => {
//     config.responseType = 'blob'
//     let currentAccessToken = localStorage.getItem('accessToken')
//     if (!!currentAccessToken) {
//       //  if (needToUpdate(currentAccessToken)) {
//       //      await refreshRequest()
//       //  }
//       config.headers.Authorization = `Bearer ${currentAccessToken}`
//       //config.headers.Cookie = localStorage.getItem('refreshToken')
//     }
//     return config
//   },
//   error => {}
// )

// const needToUpdate = (token: string) => {
//   let currentDate = new Date()

//   let decodedToken = JSON.parse(atob(token.split('.')[1]).toString())

//   console.log(decodedToken.exp - decodedToken.iat)
//   console.log(decodedToken)
//   console.log('refresh: ', currentDate.getTime() > decodedToken.exp * 1000)
//   return currentDate.getTime() > decodedToken.exp * 1000
// }

// $api.interceptors.request.use(
//   async config => {
//     const BASE_URL = !!localStorage.getItem('isAuth')
//       ? sanitizedConfig.REACT_APP_COMPANY_API_URL
//       : sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL

//     const urlArray = config.url?.split('/')
//     config.baseURL = BASE_URL
//     console.log(config.baseURL)
//     if (config.url === '/v1/web/auth/refresh') return config
//     console.log(urlArray)
//     const reversedUrlArray = urlArray?.reverse()
//     if (reversedUrlArray) {
//       if (
//         (urlArray?.length === 5 && reversedUrlArray[0] === 'base64') ||
//         (reversedUrlArray[0] === 'buffer' && config.method === 'get')
//       ) {
//         config.baseURL = sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL
//       }

//       if (urlArray?.reverse()[0] === 'files' && config.method === 'get') {
//         config.responseType = 'blob'
//       }
//     }

//     let currentAccessToken = localStorage.getItem('accessToken')
//     if (!!currentAccessToken) {
//       //  if (needToUpdate(currentAccessToken)) {
//       //      await refreshRequest()
//       //  }
//       config.headers.Authorization = `Bearer ${currentAccessToken}`
//       //config.headers.Cookie = localStorage.getItem('refreshToken')
//     }
//     console.log('base url')
//     console.log(config.baseURL)
//     console.log('isAuth')
//     console.log(!!localStorage.getItem('isAuth'))
//     return config
//   },
//   error => {
//     console.log('Ошибка!')
//     console.log(error)
//   }
// )

// $api.interceptors.response.use(
//   config => {
//     if (config.data?.access_token) {
//       localStorage.setItem('accessToken', config.data.access_token)
//     }
//     if (config.data?.refresh_token) {
//       localStorage.setItem('refreshToken', config.data.refresh_token)
//     }
//     return config
//   },
//   async error => {
//     if (!error.response) {
//       console.error('Нет ответа от сервера:', error)
//       return Promise.reject(error)
//     }

//     const originalRequest = error.config
//     if (error.response.status === 401 && originalRequest && !originalRequest._isRetry) {
//       originalRequest._isRetry = true
//       try {
//         const currentToken = localStorage.getItem('accessToken')
//         if (!currentToken) {
//           localStorage.removeItem('isAuth')
//           window.location.href = '/login'
//           return Promise.reject(error)
//         }

//         const response = await axios.request({
//           method: 'post',
//           url: sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL + '/v1/web/auth/refresh',
//           headers: { Authorization: `Bearer ${currentToken}` },
//           withCredentials: true,
//         })

//         if (response.data?.access_token) {
//           localStorage.setItem('accessToken', response.data.access_token)
//           originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`
//           return $api.request(originalRequest)
//         } else {
//           throw new Error('Не получен новый токен')
//         }
//       } catch (e) {
//         console.error('Ошибка обновления токена:', e)
//         localStorage.removeItem('accessToken')
//         localStorage.removeItem('refreshToken')
//         localStorage.removeItem('isAuth')
//         window.location.href = '/login'
//         return Promise.reject(e)
//       }
//     }
//     return Promise.reject(error)
//   }
// )
